import { apiClient } from './client';

export interface Hypothesis {
  id: number;
  name: string;
  comment: string | null;
  created_at: string;
  updated_at: string;
  blocks_count?: number;
}

export interface HypothesisBlock {
  id: number;
  hypothesis_id: number;
  bloc_id: number;
  position_x: number;
  position_y: number;
  rotation: number;
  z_order: number;
  locked?: boolean;
  created_at: string;
  bloc: {
    id: number;
    object_name: string;
    inventory_number: string | null;
    description?: string | null;
    fragment_emplacement?: string | null;
    fragment_identification?: string | null;
    poids_estime_kg?: number | null;
    image_path: string;
    scale_px_per_mm: number | null;
    image_width?: number | null;
    image_height?: number | null;
    composite_slug?: string | null;
    real_size_x_mm?: number | null;
    real_size_y_mm?: number | null;
    real_size_z_mm?: number | null;
    updated_at?: string;
  };
}

export interface CanvasGroup {
  id: string;
  parentId: string | null;
  name?: string;
  blockIds: number[];
  groupIds: string[];
}

export interface HypothesisWithDetails extends Hypothesis {
  blocks: HypothesisBlock[];
  annotations: any[];
  groups: CanvasGroup[];
}

export interface CreateHypothesisDto {
  name: string;
  comment?: string;
}

export interface SaveCanvasStateDto {
  blocks: {
    bloc_id: number;
    position_x: number;
    position_y: number;
    rotation: number;
    z_order: number;
    locked?: boolean;
  }[];
  groups?: CanvasGroup[];
}

export const hypothesesApi = {
  getAll: async (): Promise<Hypothesis[]> => {
    const response = await apiClient.get<Hypothesis[]>('/api/hypotheses');
    return response.data;
  },

  getById: async (id: number): Promise<HypothesisWithDetails> => {
    const response = await apiClient.get<HypothesisWithDetails>(`/api/hypotheses/${id}`);
    return response.data;
  },

  create: async (data: CreateHypothesisDto): Promise<Hypothesis> => {
    const response = await apiClient.post<Hypothesis>('/api/hypotheses', data);
    return response.data;
  },

  update: async (id: number, data: Partial<CreateHypothesisDto>): Promise<Hypothesis> => {
    const response = await apiClient.put<Hypothesis>(`/api/hypotheses/${id}`, data);
    return response.data;
  },

  saveCanvasState: async (id: number, state: SaveCanvasStateDto): Promise<HypothesisWithDetails> => {
    const response = await apiClient.post<HypothesisWithDetails>(`/api/hypotheses/${id}/save`, state);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/hypotheses/${id}`);
  },

  duplicate: async (id: number, name?: string): Promise<HypothesisWithDetails> => {
    const response = await apiClient.post<HypothesisWithDetails>(
      `/api/hypotheses/${id}/duplicate`,
      name ? { name } : {}
    );
    return response.data;
  },
};
